'use client';

import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { TrackingFunction } from '../types';

export const useExpandableCardsItemToggleTracking = (props = {}, autoTrack: boolean = false): TrackingFunction => {
  return useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.EXPANDABLE_CARD_ITEM_TOGGLED,
      properties: props,
    },
    autoTrack,
  );
};
